'use client'

import { useEffect } from 'react'

function focusTarget(target: HTMLElement) {
  const hadTabIndex = target.hasAttribute('tabindex')

  if (!hadTabIndex) {
    target.setAttribute('tabindex', '-1')
  }

  target.focus({ preventScroll: true })

  if (!hadTabIndex) {
    target.addEventListener(
      'blur',
      () => {
        target.removeAttribute('tabindex')
      },
      { once: true },
    )
  }
}

export function CleanHashNavigation() {
  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return
      }

      const link = (event.target as Element | null)?.closest('a[href^="#"]')

      if (!link) {
        return
      }

      const hash = link.getAttribute('href')

      if (!hash || hash === '#') {
        return
      }

      const target = document.getElementById(decodeURIComponent(hash.slice(1)))

      if (!target) {
        return
      }

      event.preventDefault()
      target.scrollIntoView({ behavior: 'smooth' })
      focusTarget(target)
    }

    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  return null
}
